import { createApp } from 'vue';
import App from './App.vue';
import router from "@/routes/index.js";
import store from "@/store/index.js";
import i18n from "@/i18n/index.js";
import { VueQueryPlugin } from '@tanstack/vue-query'

let app = createApp(App);
app.use(store).use(router).use(i18n).use(VueQueryPlugin).mount("#app");